/** 데스크톱 GNB 요소 id — 접기 버튼의 aria-controls 대상. */
export const DESKTOP_NAV_ID = 'admin-desktop-gnb';

/** 모바일 드로어 요소 id — 헤더 햄버거 버튼의 aria-controls 대상. */
export const MOBILE_DRAWER_ID = 'admin-mobile-drawer';
